// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1fjnm","header":"MessagesList_header__2zUZV","chat":"MessagesList_chat__1MlaZ"};